import Form from './Form/Form';
import { useLocalization } from 'src/utils/useLocalization';
import {
    DealerAssociation,
    DealerPermission,
} from 'src/services/models/dealer-management.service';
import Notification, {
    NotificationType,
} from 'src/components/ui/notification/Notification';
import React, { Dispatch, SetStateAction, useState } from 'react';

import './styles.scss';

interface IBodyProps {
    backClickHandler: Function;
    setSuccessNotification: Dispatch<SetStateAction<boolean>>;
    dealerPermissions: Array<DealerPermission>;
    dealerAssociations: Array<DealerAssociation>;
    isDSMSearch?: boolean;
}

const Body: React.FC<IBodyProps> = ({
    backClickHandler,
    setSuccessNotification,
    dealerPermissions,
    dealerAssociations,
    isDSMSearch = false,
}) => {
    const { addNewUser } = useLocalization();
    const [isError, setIsError] = useState<boolean>(false);

    return (
        <div className={'new-user-container__body'}>
            {isError && (
                <Notification
                    content={addNewUser.NOTIFICATION_ERROR_REQUEST}
                    type={NotificationType.ERROR}
                    visibility={isError}
                    setVisibility={setIsError}
                    withoutClose={true}
                />
            )}
            <div className={'new-user-container__body-header'}>
                {addNewUser.BODY_HEADER}
            </div>
            <div className='new-user-container__body-allfields'>
                <span>*</span>
                {addNewUser.BODY_ALLFIELDS}
            </div>
            <Form
                backClickHandler={backClickHandler}
                setSuccessNotification={setSuccessNotification}
                setErrorNotification={setIsError}
                dealerPermissions={dealerPermissions}
                dealerAssociations={dealerAssociations}
                isDSMSearch={isDSMSearch}
            />
        </div>
    );
};

export default Body;
